import { QueryObserverBaseResult, useQuery } from "react-query";
import { queryKeys } from "../../query";
import api from "../../client";
import { toQueryString } from "../../../common/utils";
import {
  PlacementEnvironmentTemplateListQueryParams,
  PlacementEnvironmentTemplateListResponseData,
} from "../../types/placement-environment-template";

export const getData = async (
  params: PlacementEnvironmentTemplateListQueryParams,
) => {
  const { data } = await api.get<PlacementEnvironmentTemplateListResponseData>(
    `/placement-environment-templates${toQueryString(params)}`,
  );

  return data;
};

export const usePlacementEnvironmentTemplates = (
  params: PlacementEnvironmentTemplateListQueryParams,
): QueryObserverBaseResult<PlacementEnvironmentTemplateListResponseData> => {
  const { data, ...props } = useQuery(
    queryKeys.placementEnvironmentTemplateListPage(params),
    () => getData(params),
  );
  return { data, ...props };
};
